<template>
  <div>
    <v-expansion-panels v-model="panel" multiple>
      <details-form :isCreate="isCreate" :isEdit="isEdit" @autoScroll="openPanel" :seasonalBookingRule="seasonalBookingRule" :place="place" />
      <check-in-days-table id="second" :isCreate="isCreate" :isEdit="isEdit" @autoScroll="openPanel" :bookingRule="seasonalBookingRule" :isFinalized="seasonalBookingRuleIsFinalised(seasonalBookingRule.id)" />
    </v-expansion-panels>
    <div class="text-right mt-8" v-if="!seasonalBookingRuleIsFinalised(seasonalBookingRule.id)">
      <v-alert v-html="$t('page-rules.seasonal-rule.actions.finalise.warning-cannot-finalise')" outlined type="warning" text class="mb-2 text-left" v-if="!seasonalBookingRuleCanFinalise(seasonalBookingRule.id)"></v-alert>
      <v-btn v-html="$t('page-rules.seasonal-rule.actions.finalise.button')" color="primary" large @click.stop="finishRuleHandler()" :disabled="!seasonalBookingRuleCanFinalise(seasonalBookingRule.id)"></v-btn>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { useBookingRuleStore, useUserStore } from '@/stores'
import DetailsForm from './DetailsForm'
import CheckInDaysTable from '../base-rule/CheckInDaysTable.vue'
import { clone } from 'ramda'

export default {
  data () {
    return {
      saving: false,
      panel: [0],
      valid: true,
      completed: false,
    }
  },
  props: {
    place: {
      type: Object,
      required: true,
    },
  },
  methods: {
    clone,
    ...mapActions(useBookingRuleStore, ['httpUpdateSeasonalBookingRule']),
    finishRuleHandler () {
      const cloneSeasonalBookingRule = this.clone(this.seasonalBookingRule)
      cloneSeasonalBookingRule.active = true

      this.httpUpdateSeasonalBookingRule({ seasonalBookingRule: cloneSeasonalBookingRule })
        .then(() => {
          // redirect to base rules page
          this.$router.push({ name: 'place-rules-manage' })
        })
        .catch()
    },
    openPanel (index) {
      this.panel.push(index)
    },
    openPopulatedSections () {
      const validDays = this.seasonalBookingRule.stayLengths.filter(([min, max, checkOut]) => min > 0 && max > 0 && checkOut > 0)

      if (validDays.length > 0) {
        this.panel.push(1)
      }
    },
  },
  computed: {
    ...mapState(useUserStore, ['currentUserHasRole']),
    ...mapState(useBookingRuleStore, {
      seasonalBookingRuleFindById: 'findById',
      seasonalBookingRuleIsFinalised: 'isFinalised',
      seasonalBookingRuleCanFinalise: 'canFinaliseBookingRule',
    }),
    seasonalBookingRule () {
      console.log('seasonal booking rule', this.$route.params.ruleId)
      return (
        this.seasonalBookingRuleFindById(this.$route.params.ruleId) || {
          place: this.place['@id'],
          seasonalBookingRuleDates: [],
          label: '',
          dates: {
            start: null,
            end: null,
          },
          stayLengths: [
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0],
          ],
        }
      )
    },
    isCreate () {
      return !this.isEdit
    },
    isEdit () {
      return 'id' in this.seasonalBookingRule
    },
  },
  mounted () {
    this.openPopulatedSections()
  },
  components: {
    DetailsForm,
    CheckInDaysTable,
  },
  beforeRouteLeave: function (to, from, next) {
    // reset page layout before leaving
    this.panel = [0]
    next()
  },
}
</script>
